var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "700" },
      model: {
        value: _vm.downloadConfirmDialogVisible,
        callback: function ($$v) {
          _vm.downloadConfirmDialogVisible = $$v
        },
        expression: "downloadConfirmDialogVisible",
      },
    },
    [
      _c("customDialog", {
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [_vm._v(" " + _vm._s(_vm.tmb("titleCreateVideo")) + " ")]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  "v-col",
                  { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "ma-0 pa-0 pt-5 pb-7 pl-7 pr-7 content",
                        staticStyle: { height: "300px" },
                        attrs: { cols: "12" },
                      },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "ma-0 pa-0 mb-4 text-left",
                            attrs: { cols: "12" },
                          },
                          [_vm._v(_vm._s(_vm.tmb("isOkCreate")))]
                        ),
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0 mb-6",
                            attrs: { align: "center" },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0 pr-2 text-left",
                                attrs: { cols: "2" },
                              },
                              [_vm._v(_vm._s(_vm.tmb("device")))]
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0 text-left",
                                attrs: { cols: "10" },
                              },
                              [_vm._v(_vm._s(_vm.streamData.cameraName))]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0 mb-6",
                            attrs: { align: "center" },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0 pr-2 text-left",
                                attrs: { cols: "2" },
                              },
                              [_vm._v(_vm._s(_vm.tmb("durationDateTime")))]
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0 text-left",
                                attrs: { cols: "10" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.params.beginTime
                                        .replace("T", " ")
                                        .substring(0, 16) +
                                        " ~ " +
                                        _vm.params.endingTime
                                          .replace("T", " ")
                                          .substring(0, 16)
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0 mb-6",
                            attrs: { align: "center" },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0 pr-2 text-left",
                                attrs: { cols: "2" },
                              },
                              [_vm._v(_vm._s(_vm.tmb("durationTimeColon")))]
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0 text-left",
                                attrs: { cols: "10" },
                              },
                              [_vm._v(_vm._s(_vm.downloadTime + "分"))]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0 mb-6",
                            attrs: { align: "center" },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0 pr-2 text-left",
                                attrs: { cols: "2" },
                              },
                              [_vm._v(_vm._s(_vm.tmb("fileName")))]
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0 text-left",
                                attrs: { cols: "10" },
                              },
                              [_vm._v(_vm._s(_vm.dataName))]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      {
                        staticClass: "ma-0 pa-0 pb-2",
                        attrs: { align: "center", justify: "center" },
                      },
                      [
                        !_vm.loading
                          ? _c(
                              "v-btn",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: {
                                  id: "grey_btn",
                                  width: "8rem",
                                  height: "2rem",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.downloadConfirmDialogVisible = false
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.t("cancel")))]
                            )
                          : _vm._e(),
                        _c(
                          "v-btn",
                          {
                            staticClass: "ma-0 pa-0 ml-2",
                            attrs: {
                              id: "blue_btn",
                              loading: _vm.loading,
                              width: "8rem",
                              height: "2rem",
                            },
                            on: { click: _vm.confirm },
                          },
                          [_vm._v(_vm._s(_vm.tmb("create")))]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }